import createStore from "astrid-helpers/src/createStore";
import samplesToMs from "astrid-helpers/src/samplesToMs";
export const [getStep, setStep, useStep] = createStore(samplesToMs(1, 44100));
//# sourceMappingURL=step.js.map